module.exports = __webpack_public_path__ + "static/media/pic2.cc897a7c.jpg";